import Vue from 'vue';

/**
 * Saves queue filter state to the backend UserSettings via SignalR.
 * Also updates the reactive userSettings on $root for immediate access.
 */
export function saveQueueFilters(vm: Vue, settingsKey: string, filters: Record<string, any>): void {
    const value = JSON.stringify(filters);
    if ((vm as any).$saveUserSetting) {
        (vm as any).$saveUserSetting(settingsKey, value);
    }
    if (vm.$root?.$data?.userSettings) {
        Vue.set(vm.$root.$data.userSettings, settingsKey, value);
    }
}

/**
 * Loads queue filter state from the backend UserSettings.
 * Returns null if no saved filters exist.
 */
export function loadQueueFilters(vm: Vue, settingsKey: string): Record<string, any> | null {
    const settings = vm.$root?.$data?.userSettings;
    if (!settings) return null;
    const value = settings[settingsKey];
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
}

